import { render, staticRenderFns } from "./set-role-modal.vue?vue&type=template&id=7905f634"
import script from "./set-role-modal.vue?vue&type=script&lang=js"
export * from "./set-role-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports